<!--
 * @Author: Junchi Zhao
 * @LastEditors: CDH
 * @Description: 
-->
<template>
  <div class="simplePage df">
    <!-- 系统为质量监管子系统时 -->
    <template v-if="appId === '007'">
      <div class="leftTable df fdc">
        <kb class="kbCard cardStyle"></kb>
        <qyyztz class="qyyztzCard cardStyle"></qyyztz>
        <lnyzzl class="lnyzzlCard cardStyle"></lnyzzl>
      </div>
      <div class="rightTable df fdc">
        <tq class="tqCard cardStyle"></tq>
        <bzsl class="bzslCard cardStyle"></bzsl>
      </div>
    </template>
    <template v-else>
      <default-index class="fg1"></default-index>
    </template>
  </div>
</template>

<script>
export default {
  components: {
    DefaultIndex: () => import("./components/defaultIndex.vue"),
    kb: () => import("./components/kb.vue"),
    tq: () => import("./components/tq.vue"),
    bzsl: () => import("./components/bzsl.vue"),
    lnyzzl: () => import("./components/lnyzzl.vue"),
    qyyztz: () => import("./components/qyyztz.vue"),
  },
  data() {
    return {
      appId: "",
    };
  },
  beforeCreate() {},
  created() {
    const app = JSON.parse(sessionStorage.getItem("nfgs")).app;
    this.appId = app.appId;
  },
  beforeMount() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.simplePage {
  width: 100%;
  height: 100%;
  .cardStyle {
    background: #ffffff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
  }
  .leftTable {
    width: calc(74% - 8px);
    margin-right: 16px;
    flex-grow: 0;
    flex-shrink: 0;
    .kbCard {
      height: 16%;
      margin-bottom: 16px;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .qyyztzCard {
      height: calc(42% - 16px);
      margin-bottom: 16px;
      flex-grow: 0;
      flex-shrink: 0;
    }
    .lnyzzlCard {
      height: calc(42% - 16px);
      flex-grow: 0;
      flex-shrink: 0;
    }
  }
  .rightTable {
    width: calc(26% - 8px);
    flex-grow: 0;
    flex-shrink: 0;
    .tqCard {
      height: 32%;
      flex-grow: 0;
      flex-shrink: 0;
      margin-bottom: 16px;
    }
    .bzslCard {
      height: calc(68% - 16px);
      flex-grow: 0;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/jh/pages/index/index.vue